import type { GetStaticProps } from 'next';
import { fetchBlogPosts } from '../utils/api/fetchStrapiData';
import { PrivacyPolicy } from '../views/privacy-policy';

export const getStaticProps: GetStaticProps = async () => {
  const data = await fetchBlogPosts();

  return {
    props: { blogPosts: data },
  };
};
export default PrivacyPolicy;
